import * as React from 'react';
import { Electron } from 'pos/common';
import { ActionButtonDefinition } from 'pos/ui';
import { useOverlayExecutor } from 'core/ui-next/modal';
import { useIsOnTop } from 'core/ui-next/modal/ModalHooks';

export function useFunctionKeyOn(buttons: Nullable<ActionButtonDefinition>[]) {

	const fnKeyPressed = React.useRef(false);
	const { execute } = useOverlayExecutor();

	const isOnTop = useIsOnTop();

	const onFunctionKeyPressed = React.useCallback(async (ev: KeyboardEvent): Promise<void> => {

		if (!isOnTop)
			return;

		if (fnKeyPressed.current.valueOf())
			return;

		try {
			fnKeyPressed.current = true;

			const button = buttons.find(x => x?.fnKey === ev.key);
			if (!button)
				return;

			await execute({
				// Bloqueo desde el principio la pantalla. Como el overlay tarda un tiempo ser visible, si todo el proceso
				// es local y se ejecuta rápidamente, no se llega a ver y no hay parpadeos raros.
				overlay: 'on-start',
				waitForPendingRequests: true,
				action: async () => button.action?.()
			});
		}
		finally {
			fnKeyPressed.current = false;
		}
	}, [execute, buttons, isOnTop]);

	React.useEffect(() => {
		if (Electron.isEnabled())
			document.addEventListener('keydown', onFunctionKeyPressed);

		return () => document.removeEventListener('keydown', onFunctionKeyPressed);
	}, [onFunctionKeyPressed]);
}
